import React from 'react';
import PropTypes from 'prop-types';
import { MagnifyingGlassIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import { Input, IconWrapper } from '../styles/UserSearchBar.styles';

const UserSearchBar = ({ searchTerm, setSearchTerm }) => {
  const onInputChange = e => {
    setSearchTerm(e.target.value);
  };

  const clearSearchTerm = () => {
    setSearchTerm('');
  };

  return (
    <Box position="relative" horizontal mb={2}>
      <IconWrapper searchTerm={searchTerm}>
        <MagnifyingGlassIcon />
      </IconWrapper>
      <Input
        grow
        type="text"
        maxLength={75}
        value={searchTerm}
        onChange={onInputChange}
        placeholder="Search for an existing user"
        setFieldValue={clearSearchTerm}
      />
    </Box>
  );
};

UserSearchBar.proptype = {
  adminSearchRef: PropTypes.object.isRequired,
  onUserSearch: PropTypes.func.isRequired,
};

export default UserSearchBar;
